import { useQuery } from '@tanstack/react-query';
import { trackingService } from '@/services/tracking.service';
import { retryUnlessSetupError, trackerKeys } from './trackerQuery';

export function useTrackerHealth() {
  return useQuery({
    queryKey: trackerKeys.health,
    queryFn: () => trackingService.health(),
    retry: retryUnlessSetupError,
  });
}
